<template>
  <div>
    <div class="content-heading" v-show="mechanicsHeaderShow">
      <i class="ic-head-icon">
        <img src="@/assets/images/sidebar/mechanics.svg" alt />
      </i>
      <h4 class="head-title">Program</h4>
      <i class="ic-tooltip" id="help"></i>
      <b-popover
        target="help"
        triggers="hover"
        content="Customize your overall loyalty program mechanics."
      ></b-popover>
      <div class="head-tabs">
        <b-nav tabs>
          <b-nav-item
            :to="{ path: '/mechanics/achievement'}"
            v-if="permission.hasAccess('mechanics.achievement')"
          >Achievement</b-nav-item>
          <b-nav-item
            :to="{ path: '/mechanics/user-points' }"
            v-if="permission.hasAccess('mechanics.points-mechanics')"
          >
            Points
          </b-nav-item>
          <template>
            <b-nav-item
              :to="{ path: '/mechanics/membership-tiers' }"
              v-if="permission.hasAccess('mechanics.membership')"
            >Membership Tiers</b-nav-item>
          </template>
          <b-nav-item
            :to="{ path: '/mechanics/guidelines' }"
            v-if="permission.hasAccess('mechanics.guidelines')"
          >Guidelines</b-nav-item>
          <template>
            <b-nav-item
              :to="{ path: '/mechanics/capping' }"
              v-if="permission.hasAccess('mechanics.capping')"
            >Capping</b-nav-item>
          </template>
        </b-nav>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import _ from "lodash";
import permission from "../../services/user.permission";
import { mapState } from "vuex";

export default {
    name: "mechanics",
    data() {
        return {
            msg: "Mechanics",
            permission: permission,
            env: process.env.VUE_APP_MODE
        };
    },
    computed: {
        ...mapState("auth", ["enabledTopUps"]),
        mechanicsHeaderShow: function() {
            let subpages = [
                    "create-customer-design",
                    "create-merchant-design",
                    "update-customer-design",
                    "update-merchant-design"
                ],
                _self = this,
                _show = true;
            _.each(subpages, function(value) {
                if (_self.$route.path.includes(value)) {
                    _show = false;
                }
            });
            return _show;
        },
        ...mapState("auth", {
            user: state => state.user
        })
    },
};
</script>
